const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const EmailTemplateBuilderQuery: any = {
    GetSectionData: Backofficebff + '/v1/emailtemplating/sections/list',
    GetAllSectionSummaryList: Backofficebff + '/v1/emailtemplating/sections/getallsectionsummarylist',
    GetSingleSectionData: Backofficebff + '/v1/emailtemplating/sections/',
    GetTemplatesData: Backofficebff + '/v1/emailtemplating/templates/list',
    GetTemplatePreview: Backofficebff + '/v1/emailtemplating/templates/preview',
    SendTestMail: Backofficebff + '/v1/notification/send-generic-mail',
};
